import axios from 'axios';
import { store } from '../store/store';
import { getToken, getJWTToken, getNominatorMail, getUserGraphId } from './common';
import { setShowError } from '../actions/errorActions'
import { data } from "./local";
import { getConfig } from '../services/ConfigService';

import { appInsights } from '../AppInsights';
import { Exception, SeverityLevel } from '@microsoft/applicationinsights-web';
import { setHideLoader, setShowLoader } from '../actions/loaderActions';
import { isNullOrUndefined } from '@microsoft/applicationinsights-core-js';



let APIBaseURL: any;
let ReportURL: any;


const content: any = data;
let { searchBox, errorMessage } = content[store.getState().lang];

const getcorrelationId = () => {
    return sessionStorage.getItem("correlationId");
}

function validateData(options: any) {
    Object.entries(options).forEach(([key, value]) => {
        if(key.toLowerCase() == "title" || key.toLowerCase() == "manageremail" || key.toLowerCase() == "managername"){
            if(isNullOrUndefined(value)){
                options[key]= "NA";
            }
        }
      });
      return options;
  }

const getHeaders = () => {
    return new Promise(async (resolve: any) => {
        const token = await getJWTToken();
        const config: any = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
                'ConsistencyLevel': 'eventual',
                CorrelationId: getcorrelationId()
            }
        }
        resolve(config)
    })
}

const getGraphHeaders = () => {
    return new Promise(async (resolve: any) => {
        const token = await getToken();
        const config: any = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
                'ConsistencyLevel': 'eventual',
                CorrelationId: getcorrelationId()
            }
        }
        resolve(config)
    })
}



export const getReportUrl = () => {
    return getConfig().then((config: any) => {
        let ReportURL = config.ReportUrl;
        return new Promise((resolve: any) => {
            resolve(ReportURL)
        })
    });
}

export const getInstrumentationKey = () => {
    return getConfig().then((config: any) => {
        let InstrumentationKey = config.InstrumentationKey;
        return new Promise((resolve: any) => {
            resolve(InstrumentationKey)
        })
    });
}

export const getViaSupportGroupEmail = async () => {
    return await getConfig().then((config: any) => {
        let emails: any[] = [];
        emails.push(config.VIASupportEmail);
        emails.push(config.ServiceNowDL)
        return new Promise(async (resolve: any) => {
            resolve(emails);
        })
    });
}

export const getNominatorId = (options: any) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async(resolve: any) => {
            const createNominatorURL = `${APIBaseURL}/api/UserEntity/user-management/user`;
            const Header:any=  await getHeaders();
            axios.post(createNominatorURL, validateData(options), { headers:Header.headers})
                .then(res => {
                    resolve(res.data);
                    appInsights.trackEvent({ name: "getNominatorId", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), CalledFor: options.graphId } });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getNominatorId", AccountIdentifier: getUserGraphId(), CalledFor: options.graphId, CorrelationId: getcorrelationId() ,Error:error, ErrorMessage: error.response?.data?.errors} })
                   
                    if (error?.response?.status === 500) {

                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    } else if (error?.response?.status === 400) {

                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                    } else {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    }
                })
        })
    });

}

export const validateNominee = (options: any) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async(resolve: any) => {
            const createValidateNomineeURL = `${APIBaseURL}/api/UserEntity/user-management/validate`;
           
            const Header:any=  await getHeaders();
            axios.post(createValidateNomineeURL, validateData(options),  { headers:Header.headers})
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "validateNominee", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), CalledFor: options.graphId } });
                })  // return promise with Id
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: { MethodName:"validateNominee", AccountIdentifier: getUserGraphId(), CalledFor: options.graphId, CorrelationId: getcorrelationId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    if (error?.response?.status === 500) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    } else if (error?.response?.status === 400) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                    } else {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    }
                })
        })
    });

}

//user-management/saveawardeeimage
export const addAwardeeDetails = (options: FormData) => {    
    store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async(resolve: any) => {
            const addAwardeeDetailsURL = `${APIBaseURL}/api/Admin/admin-management/saveawardeedetails`;
          
            const Header:any=  await getHeaders();
            axios.post(addAwardeeDetailsURL, options,  { headers:Header.headers})
                .then(res => {
                   store.dispatch(setHideLoader({ show: false }));
                   resolve(res.data)
                   appInsights.trackEvent({ name: "addAwardeeDetails", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })  // return promise with Id
                .catch(error => {
                   store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"addAwardeeDetails", AccountIdentifier: getUserGraphId(), CorrelationId: getcorrelationId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    if (error?.response?.status === 500) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    } else if (error?.response?.status === 400) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                    }
                     else {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    }
                })
        })
    });
}

export const getAwardeeList = () => {
     store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;
        return new Promise(async(resolve: any) => {
            const awardeeDataUrl = `${APIBaseURL}/api/Admin/admin-management/getawardee-list`;
            const Header:any=  await getHeaders();

            axios.get(awardeeDataUrl,  { headers:Header.headers})
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getAwardeeList", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: { MethodName:"getAwardeeList", CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                })
        })

    });
}



export const insertNomination = (options: any) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async(resolve: any) => {
            const createNominationURL = `${APIBaseURL}/api/UserEntity/nomination-management/nominate`;
            const Header:any=  await getHeaders();
            axios.post(createNominationURL, validateData(options),  { headers:Header.headers})
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "insertNomination", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })  // return promise with Id
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: { MethodName:"insertNomination", CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    if (error?.response?.status === 500) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    } else if (error?.response?.status === 400) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                    } else {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    }
                })
        })
    });

}

export const updateNominationStateAfterSendingEmails = (options: any) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async(resolve: any) => {
            const createNominationURL = `${APIBaseURL}/api/UserEntity/nomination-management/update-state`;
            const Header:any=  await getHeaders();
            axios.post(createNominationURL, validateData(options),  { headers:Header.headers})
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "updatenominationaftersendingemails", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })  // return promise with Id
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: { MethodName:"insertNomination", CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    if (error?.response?.status === 500) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    } else if (error?.response?.status === 400) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                    } else {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    }
                })
        })
    });

}


export const sendMail = (options: any) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const createMailURL = `${APIBaseURL}/api/UserEntity/user-management/sendEmail`;
           
            const token = await getJWTToken();
            axios.post(createMailURL, options, { headers: { Authorization: 'Bearer ' + token, CorrelationId:getcorrelationId(),ContentType: 'HTML' } })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "sendMail", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })  // return promise with Id
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: { MethodName:"sendMail", CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })

                    if (error?.response?.status === 500) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    } else if (error?.response?.status === 400) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                    } else {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    }
                })
        })
    });

}

export const getDraftNominations = (nominatorId: any, year: any, mail: any) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async(resolve: any) => {
            const categoryDetailsURL = `${APIBaseURL}/api/UserEntity/nomination-management/draft/${nominatorId}/year/${year}/mail/${mail}`;
            const Header:any=  await getHeaders();

            axios.get(categoryDetailsURL, { headers: Header.headers })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getDraftNominations", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getDraftNominations",  CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    if (error?.response?.status === 500) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    } else if (error?.response?.status === 400) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                    } else if (error?.response?.status === 404) {
                        resolve({ nominations: [] });
                    } else {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    }
                    resolve([]);
                }
                )
        })
    });

}

export const deleteNominations = (nominationId: any) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const deleteNominationDetailsURL = `${APIBaseURL}/api/UserEntity/nomination-management/delete/${nominationId}`;
            const Header:any=  await getHeaders();

            axios.get(deleteNominationDetailsURL, { headers: Header.headers })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "deleteDraftNomination", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"deleteDraftNomination",  CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    if (error?.response?.status === 500) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    } else if (error?.response?.status === 400) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                    } else if (error?.response?.status === 404) {
                        resolve({ nominations: [] });
                    } else {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    }
                    resolve([]);
                }
                )
        })
    });

}


export const getSubmittedNominations = (nominatorId: any, year: any, mail: any) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async(resolve: any) => {

            const categoryDetailsURL = `${APIBaseURL}/api/UserEntity/nomination-management/submitted/${nominatorId}/year/${year}/mail/${mail}`
            const Header:any=  await getHeaders();
         
            axios.get(categoryDetailsURL, { headers: Header.headers })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getSubmittedNominations", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(
                    error => {
                        
                        appInsights.trackException({ error: new Error(error),severityLevel: SeverityLevel.Error,properties: {MethodName:"getSubmittedNominations", CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(),Error:error, ErrorMessage: error.response?.data?.errors} })
                        //appInsights.trackException({Exception:error,SeverityLevel:"",Message:"This is msg",name:"ABC EXCEPTION", properties: { CorrelationId: correlationId,Error:error, ErrorMessage: error.response?.data?.errors} })
                        if (error?.response?.status === 500) {
                            store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                        } else if (error?.response?.status === 400) {
                            store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                        } else if (error?.response?.status === 404) {
                            resolve({ nominations: [] });
                        } else {
                            store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                        }
                        resolve([]);
                    }

                )
        })
    });

}

export const getAdminList = () => {
    
     store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {

            const adminListURL = `${APIBaseURL}/api/Admin/admin-management/getadmins`
            const Header:any=  await getHeaders();          

            axios.get(adminListURL, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getAdminList", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} });
                })
                .catch(
                    error => {
                        store.dispatch(setHideLoader({ show: false }));
                        appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getAdminList",  CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                        if (error?.response?.status === 500) {
                            store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))

                        } else if (error?.response?.status === 400) {
                            store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                        } else if (error?.response?.status === 404) {
                            resolve({ nominations: [] });
                        } else {
                            store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                        }
                        resolve([]);
                    }

                )
        })
    });
}

export const getReceivedNominations = (nomineeId: any, year: any, mail: any) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const categoryDetailsURL = `${APIBaseURL}/api/UserEntity/nomination-management/received/${nomineeId}/year/${year}/mail/${mail}`
            const Header:any=  await getHeaders();

            axios.get(categoryDetailsURL, { headers: Header.headers })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getReceivedNominations", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getReceivedNominations",  CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    if (error?.response?.status === 500) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    } else if (error?.response?.status === 400) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                    } else if (error?.response?.status === 404) {
                        resolve({ nominations: [] });
                    } else {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    }
                    resolve([])
                })
        })
    });

}

export const getWinners = (year: any) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {

            const winnerDetailsURL = `${APIBaseURL}/api/UserEntity/nomination-management/winners/year/${year}`
            const Header:any=  await getHeaders();

            axios.get(winnerDetailsURL, { headers: Header.headers })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getWinners", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getWinners",  CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    if (error?.response?.status === 500) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    } else if (error?.response?.status === 400) {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                    } else if (error?.response?.status === 404) {
                        resolve([]);
                    } else {
                        store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    }
                    resolve([]);
                })
        })
    });

}

export const getCategoryDetails = () => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const categoryDetailsURL = `${APIBaseURL}/api/UserEntity/category-management/categories`;
            const Header:any=  await getHeaders();

            axios.get(categoryDetailsURL, { headers: Header.headers })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getCategoryDetails", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getCategoryDetails",  CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }));
                })
        })
    });
}

export const getVideoURL = () => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const videoURL = `${APIBaseURL}/api/UserEntity/nomination-management/video`;
            const Header:any=  await getHeaders();         

            axios.get(videoURL, { headers: Header.headers })
                .then(res => {
                    resolve(res?.data?.url)
                    appInsights.trackEvent({ name: "getVideoURL", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: { MethodName:"getVideoURL", CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                    resolve("#")
                })
        })
    });

}


export const getFeatureNames = (email: string) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async(resolve: any) => {
            const featureNameurl = `${APIBaseURL}/api/v1/feature/fetchFeatureNames?email=` + email;
            const Header:any=  await getHeaders();

            axios.post(featureNameurl, { headers: Header.headers })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getFeatureNames", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getFeatureNames",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))

                })
        })
    });

}

export const getUserRoleId = (email: string) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const userRoleUrl = `${APIBaseURL}/api/UserEntity/user-management/userrole?email=` + email;
            const Header:any=  await getHeaders();
       
            axios.get(userRoleUrl, { headers:Header.headers })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getUserRoleId", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getUserRoleId",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))

                })
        })
    });

}

export const getClosureData = () => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const closureDataUrl = `${APIBaseURL}/api/UserEntity/admin-management/closuredata`;
        
        const Header:any=  await getHeaders();
              
            axios.get(closureDataUrl, { headers:Header.headers})
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getClosureData", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(
                    error => {
                        appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getClosureData",  CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                        if (error?.response?.status === 500) {
                            store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                        } else if (error?.response?.status === 400) {
                            store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg400 }))
                        } else if (error?.response?.status === 404) {
                            resolve({ nominations: [] });
                        } else {
                            store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                        }
                        resolve([]);
                    }

                )
        })
    });

}

export const addClosureData = (options: any) => {
     store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const addClosureDataUrl = `${APIBaseURL}/api/Admin/admin-management/addclosuredetails`;
            const Header:any=  await getHeaders();
          
            axios.post(addClosureDataUrl, options, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "addClosureData", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"addClosureData", CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))

                })
        })
    });

}



export const getNominatorInfo = async (userId: any) => {

    return new Promise(async (resolve: any, reject: any) => {
        const createNominatorURL = `https://graph.microsoft.com/v1.0/users/${userId}`;
        let config: any = await getGraphHeaders();
        axios.get(createNominatorURL, config)
            .then(res => {
                if (res?.data)
                    resolve(res.data)
            })  // return promise with Id
            .catch(error => { })
    })

}

export const getUserCompany = async (userId: any) => {

    return new Promise(async (resolve: any, reject: any) => {
        const createNominatorURL = `https://graph.microsoft.com/v1.0/users/${userId}/companyName`;
        let config: any = await getGraphHeaders();
        axios.get(createNominatorURL, config)
            .then(res => {
                if (res?.data)
                    resolve(res.data)
            })  // return promise with Id
            .catch(error => { })
    })

}

export const getUserCity = async (userId: any) => {

    return new Promise(async (resolve: any, reject: any) => {
        const createNominatorURL = `https://graph.microsoft.com/v1.0/users/${userId}/city`;
        let config: any = await getGraphHeaders();
        axios.get(createNominatorURL, config)
            .then(res => {
                if (res?.data)
                    resolve(res.data)
            })  // return promise with Id
            .catch(error => { })
    })

}

export const getManagerInfo = async (userId: any) => {
    return new Promise(async (resolve: any, reject: any) => {
        const managerURL = `https://graph.microsoft.com/v1.0/users/${userId}/manager`;
        let config: any = await getGraphHeaders();
        axios.get(managerURL, config)
            .then(res => {
                if (res?.data)
                    resolve(res.data)
            })  // return promise with Id
            .catch(error => {
                if (error?.response?.status === 404) {
                    resolve([]);
                }
            })
    })
}

export const getAdminInfo = async () => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const AdminFetchUrl = `${APIBaseURL}/api/UserEntity/GetRoles`;
            
            const Header:any=  await getHeaders();
         
            axios.get(AdminFetchUrl, { headers: Header.headers })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getAdminInfo", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: { MethodName:"getAdminInfo", CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }));
                })
        })
    });
}

export const getAdminDetailsBasedonEmail = (email: string) => {
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const adminDetailsurl = `${APIBaseURL}/api/Admin/admin-management/AdminBasedonEmail?email=` + email;
            const Header:any=  await getHeaders();

            axios.get(adminDetailsurl, { headers: Header.headers })
                .then(res => {
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getAdminDetailsBasedonEmail", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} });
                })
                .catch(error => {
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getAdminDetailsBasedonEmail",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))

                })
        })
    });

}


export const getRegionsMinistryList = () => {
     store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;
        return new Promise(async (resolve: any) => {
            const regionsMinistryDataUrl = `${APIBaseURL}/api/Admin/admin-management/getregionsministry`;
            const Header:any=  await getHeaders();
           
            axios.get(regionsMinistryDataUrl, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getRegionsMinistryList", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getRegionsMinistryList",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                })
        })

    });
}

export const UpdateMinistryandRegion = (options: any) => {
     store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;

        return new Promise(async (resolve: any) => {
            const updateministryUrl = `${APIBaseURL}/api/Admin/admin-management/addregionsministry`;
            const Header:any=  await getHeaders();

            axios.post(updateministryUrl, options, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "UpdateMinistryandRegion", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId()} });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"UpdateMinistryandRegion", CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))

                })
        })
    });

}

export const getRegionsMinistryNominationsCount = () => {
    store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;
        return new Promise(async (resolve: any) => {
            const regionsMinistryDataUrl = `${APIBaseURL}/api/Admin/admin-management/gettotalimpactednominations`;
            const Header:any=  await getHeaders();
       
            axios.get(regionsMinistryDataUrl, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getRegionsMinistryNominationsCount", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getRegionsMinistryNominationsCount",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                })
        })

    });
}

export const getImpactedNominationsCount = () => {
    store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;
        return new Promise(async (resolve: any) => {
            const regionsMinistryDataUrl = `${APIBaseURL}/api/Admin/admin-management/getimpactednominations`;
            const Header:any=  await getHeaders();
        
            axios.get(regionsMinistryDataUrl, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getImpactedNominationsCount", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getImpactedNominationsCount",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))

                })
        })
    });

}

export const getRegionsMinistryMasterData = () => {
    store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;
        return new Promise(async (resolve: any) => {
            const regionsMinistryDataUrl = `${APIBaseURL}/api/Admin/admin-management/getregionministrymasterdata`;
            const Header:any=  await getHeaders();
            axios.get(regionsMinistryDataUrl, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getregionministrymasterdata", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getregionministrymasterdata",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                })
        })
    });
}

export const getRegionMinistryDistinctList = (dataNeeded: any) => {
    store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;
        return new Promise(async (resolve: any) => {
            const regionMinistryDataUrl = `${APIBaseURL}/api/Admin/admin-management/getregionministry/${dataNeeded}`;
            const Header:any=  await getHeaders();
            axios.get(regionMinistryDataUrl, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "get Region Ministry Distinct List", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"get Region Ministry Distinct List",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                })
        })
    });
}

export const getNomineesByYearMonthRegionMinistryList = (options: any) => {
    store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;
        return new Promise(async (resolve: any) => {
            const nomineeDataUrl = `${APIBaseURL}/api/Admin/admin-management/getnominees`;
            const Header:any=  await getHeaders();
            axios.post(nomineeDataUrl, options, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "get Nominee Year Month Region Ministry Distinct List", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"get Nominee Year Month Region Ministry  Distinct List",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                })
        })
    });
}

export const getNominationsByYearMonthRegionMinistryTitle = (options: any) => {
    store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;
        return new Promise(async (resolve: any) => {
            const nominationsDataUrl = `${APIBaseURL}/api/Admin/admin-management/getnominationsbyselecteddata`;
            const Header:any=  await getHeaders();
            axios.post(nominationsDataUrl, options, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getNominationsByYearMonthRegionMinistryTitle", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getNominationsByYearMonthRegionMinistryTitle",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                })
        })
    });
}


export const getNominationsByYearMonthRegionMinistryTitleCount= (options: any) => {
    store.dispatch(setShowLoader({ show: true }));
    return getConfig().then((config: any) => {
        APIBaseURL = config.APIBaseURL;
        return new Promise(async (resolve: any) => {
            const nominationsCountUrl = `${APIBaseURL}/api/Admin/admin-management/getnominationscount`;
            const Header:any=  await getHeaders();
            axios.post(nominationsCountUrl, options, { headers: Header.headers })
                .then(res => {
                    store.dispatch(setHideLoader({ show: false }));
                    resolve(res.data)
                    appInsights.trackEvent({ name: "getNominationsByYearMonthRegionMinsitryTitleCount", properties: { CorrelationId: getcorrelationId(), AccountIdentifier: getUserGraphId() } });
                })
                .catch(error => {
                    store.dispatch(setHideLoader({ show: false }));
                    appInsights.trackException({ error: new Error(error), severityLevel: SeverityLevel.Error,properties: {MethodName:"getNominationsByYearMonthRegionMinsitryTitleCount",  CorrelationId: getcorrelationId(),AccountIdentifier: getUserGraphId(), Error:error, ErrorMessage: error.response?.data?.errors} })
                    store.dispatch(setShowError({ show: true, title: searchBox.error, message: errorMessage.msg500 }))
                })
        })
    });
}